import React from "react";

import { Trans } from "@lingui/react/macro";

import Typography from "@mui/material/Typography";

import CopyButton from "@readai/common/components/CopyButton";
import { Img } from "@readai/common/components/styles";
import useAuth from "@readai/common/hooks/useAuth";
import usePageTitle from "@readai/common/hooks/usePageTitle";
import LINKS from "@readai/common/links";
import { getDisplayUrl, getSchedulingLinkUrl } from "@readai/common/utils";
import Stack, { Row } from "@readai/pulse/components/Stack";

import Hero from "@app/booking/assets/splash_page_hero.png";
import ROUTES from "@app/booking/routes";

import {
  Container,
  CtaButton,
  Heading,
  LeftColumn,
  LinkButtonContainer,
  RightColumn,
  StyledCopyButton,
  Text,
} from "./styles";

const SplashPage = () => {
  usePageTitle("Read Smart Scheduler");

  const { user } = useAuth();

  const schedulingLinkUrl = user?.rssLinkSettings
    ? getSchedulingLinkUrl(user?.rssLinkSettings.vanityId)
    : null;

  const displayUrl = schedulingLinkUrl ? getDisplayUrl(schedulingLinkUrl) : "";

  return (
    <Container spacing={3} variant="center">
      <LeftColumn variant="left" spacing={2}>
        <Heading>
          <Trans>Read Smart Scheduler</Trans>
        </Heading>
        <Stack spacing={3} maxWidth="100%">
          <Text>
            <Trans>
              Better meetings, simplified scheduling with AI that learns from
              your past meetings, Read Smart Scheduler automates meeting
              workflows.
            </Trans>
          </Text>
          <Text>
            <Trans>Share your personal link to get started!</Trans>
          </Text>
          {schedulingLinkUrl ? (
            <CopyButton
              copyValue={schedulingLinkUrl}
              renderButton={({ onClick }, copied) => (
                <LinkButtonContainer
                  variant="apart"
                  spacing={2}
                  onClick={onClick}
                >
                  <Typography
                    variant="bodyPrimaryMed"
                    color="text.weak"
                    noWrap
                    maxWidth="300px"
                    title={displayUrl}
                  >
                    {displayUrl}
                  </Typography>
                  <StyledCopyButton
                    sx={
                      copied
                        ? {
                            bgcolor: "icon.indicator.success.default",
                            "&:hover": {
                              bgcolor: "icon.indicator.success.default",
                            },
                          }
                        : undefined
                    }
                  >
                    {copied ? <Trans>Copied!</Trans> : <Trans>Copy</Trans>}
                  </StyledCopyButton>
                </LinkButtonContainer>
              )}
            />
          ) : (
            <Row spacing={1.5} paddingTop={1}>
              <CtaButton
                href={
                  user
                    ? ROUTES.MAIN_APP.SMART_SCHEDULER_SETTINGS
                    : ROUTES.MAIN_APP.SIGN_UP
                }
              >
                <Trans>Create your link</Trans>
              </CtaButton>
              <CtaButton variant="outlined" href={LINKS.MARKETING.RSS}>
                <Trans>Learn more</Trans>
              </CtaButton>
            </Row>
          )}
        </Stack>
      </LeftColumn>
      <RightColumn>
        <Img src={Hero} width="100%" />
      </RightColumn>
    </Container>
  );
};

export default SplashPage;
